import { useEffect, useState } from 'react';
import { useSettings } from '../context/SettingsContext';
import { getConferenceSettings } from '../services/conferenceSettingsService';

export default function useConferenceSettings() {
  const context = useSettings();
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (context) return undefined;

    let mounted = true;
    getConferenceSettings()
      .then((data) => {
        if (mounted) setSettings(data);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [context]);

  if (context) {
    return { settings: context.conferenceSettings, loading: context.loading };
  }

  return { settings, loading };
}
